import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  Upload(UploadDetail: any) {
    return this.http.post<any>(environment.API_URL + `File/Upload`,
      this.session.SetClass(UploadDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  CompanyParameter(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `CompanyParameter/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SelectDate(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `emp/SelectDate`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetDateTime(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `GetDate/GetDateTime`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  AdressDetailsGet(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `AdressDetails/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  getIPAddress() {
    return this.http.get<any>(`https://api.ipify.org/?format=json`).pipe(map(response => {
      return response;
    }));
  }

  Mobile_ESS_Get_LocalAuthDetails(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `Mobile_ESS_Get_LocalAuth/Details`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Mobile_ESS_Get_LocalAuthDetailsFromLogin(Detail: any = {}, API_URL: string) {
    return this.http.post<any>(API_URL + `Mobile_ESS_Get_LocalAuth/Details`,
      Detail
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Mobile_ESS_Update_LocalAuthUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `Mobile_ESS_Update_LocalAuth/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Mobile_ESS_Update_LocalAuthUpdateFromLogin(Detail: any = {}, API_URL: string) {
    return this.http.post<any>(API_URL + `Mobile_ESS_Update_LocalAuth/Update`,
      Detail
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_CentralizedLoginKeyGeneration(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_CentralizedLoginKey/Generation`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Ess_ChangePasswordUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `Ess_ChangePassword/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  LogOutDetails(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `LogOut/Details`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  AdminAttendanceManagementEmployeesLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AdminAttendanceManagement`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
